// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Hidden = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.586 7.585 2.707 2.707 2 3.414l2.14 2.14c-1.085.8-1.977 1.892-2.594 3.238L1.45 9l.095.208C2.94 12.252 5.744 14 9 14c1.072 0 2.095-.19 3.034-.553l2.695 2.695.707-.707-5.02-5.021L9 9zm3.346 1.932a2 2 0 0 0-2.45-2.45l-.773-.773A3 3 0 0 1 12 9c0 .462-.108.899-.295 1.29zM9 4a8.4 8.4 0 0 0-3.033.553l.787.786A7.5 7.5 0 0 1 9 5c2.794 0 5.187 1.446 6.446 4-.562 1.142-1.353 2.06-2.303 2.728l.716.716c1.085-.8 1.979-1.89 2.595-3.235L16.55 9l-.096-.208C15.06 5.748 12.256 4 9 4M2.553 9c.563-1.142 1.353-2.061 2.303-2.73l1.439 1.438C6.107 8.1 6 8.538 6 9a3 3 0 0 0 3 3c.462 0 .9-.108 1.29-.296l.96.959A7.5 7.5 0 0 1 9 13c-2.795 0-5.187-1.446-6.447-4"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(Hidden);
export default ForwardRef;
